(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-directory"] && !Shopify.designMode) return;
  try {
    
  (async function () {
    var root = document.getElementById('brands-dir');
    if (!root) return;
    var exclude = (root.dataset.exclude || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);

    // Allow-list of vendor-rule collection handles (brand-handles.json in theme Assets).
    var allow = null;
    try {
      var ar = await fetch(root.dataset.allowUrl);
      if (ar.ok) allow = await ar.json();
    } catch (e) {}

    var all = [], page = 1, batch;
    do {
      var res = await fetch('/collections.json?limit=250&page=' + page);
      batch = (await res.json()).collections || [];
      all = all.concat(batch);
      page++;
    } while (batch.length === 250);

    var brands = all.filter(function (c) {
      if (!(c.products_count > 0)) return false;
      if (exclude.indexOf(c.handle) !== -1) return false;
      return allow ? allow.indexOf(c.handle) !== -1 : true;
    }).sort(function (a, b) {
      return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' });
    });

    var list = document.getElementById('brands-list');
    var letters = document.getElementById('brands-letters');
    var search = document.getElementById('brands-search');
    var keys = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ#'.split('');

    function render(items) {
      var groups = {};
      items.forEach(function (c) {
        var ch = c.title.trim().charAt(0).toUpperCase();
        var k = /[A-Z]/.test(ch) ? ch : '#';
        (groups[k] = groups[k] || []).push(c);
      });

      letters.textContent = '';
      keys.forEach(function (k) {
        var a = document.createElement('a');
        a.textContent = k;
        if (groups[k]) { a.href = '#brand-' + (k === '#' ? '0' : k); } else { a.className = 'off'; }
        letters.appendChild(a);
      });

      list.textContent = '';
      var any = false;
      keys.forEach(function (k) {
        if (!groups[k]) return;
        any = true;
        var sec = document.createElement('section');
        sec.className = 'brands-group';
        sec.id = 'brand-' + (k === '#' ? '0' : k);
        var h = document.createElement('h2');
        h.textContent = k;
        sec.appendChild(h);
        var ul = document.createElement('ul');
        groups[k].forEach(function (c) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '/collections/' + c.handle;
          a.textContent = c.title;
          li.appendChild(a);
          ul.appendChild(li);
        });
        sec.appendChild(ul);
        list.appendChild(sec);
      });
      if (!any) list.textContent = 'No brands found.';
    }

    render(brands);
    search.addEventListener('input', function () {
      var q = search.value.toLowerCase();
      render(brands.filter(function (c) { return c.title.toLowerCase().indexOf(q) !== -1; }));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
